
export const getWellbeingTexture = (traitGroupScore) => {
    let path = '';

    if (traitGroupScore >= 100) {
        return path + 'BLD_Wellbeing_Tier100-min.png';
    }
    else if (traitGroupScore >= 90) {
        return path + 'BLD_Wellbeing_Tier090-min.png';
    }
    else if (traitGroupScore >= 80) {
        return path + 'BLD_Wellbeing_Tier080-min.png';
    }
    else if (traitGroupScore >= 70) {
        return path + 'BLD_Wellbeing_Tier070-min.png';
    }
    else if (traitGroupScore >= 60) {
        return path + 'BLD_Wellbeing_Tier060-min.png';
    }
    else if (traitGroupScore >= 50) {
        return path + 'BLD_Wellbeing_Tier050-min.png';
    }
    else if (traitGroupScore >= 40) {
        return path + 'BLD_Wellbeing_Tier040-min.png';
    }
    else if (traitGroupScore >= 30) {
        return path + 'BLD_Wellbeing_Tier030-min.png';
    }
    else if (traitGroupScore >= 20) {
        return path + 'BLD_Wellbeing_Tier020-min.png';
    }
    else if (traitGroupScore >= 10) {
        return path + 'BLD_Wellbeing_Tier010-min.png';
    }
    else if (traitGroupScore >= 0 || traitGroupScore === null) {
        return path + 'BLD_Wellbeing_Tier000-min.png';
    }
}

export const geMindsetTexture = (traitGroupScore) => {
    let path = '';

    if (traitGroupScore >= 100) {
        return path + 'BLD_Mindset_Tier100-min.png';
    }
    else if (traitGroupScore >= 90) {
        return path + 'BLD_Mindset_Tier090-min.png';
    }
    else if (traitGroupScore >= 80) {
        return path + 'BLD_Mindset_Tier080-min.png';
    }
    else if (traitGroupScore >= 70) {
        return path + 'BLD_Mindset_Tier070-min.png';
    }
    else if (traitGroupScore >= 60) {
        return path + 'BLD_Mindset_Tier060-min.png';
    }
    else if (traitGroupScore >= 50) {
        return path + 'BLD_Mindset_Tier050-min.png';
    }
    else if (traitGroupScore >= 40) {
        return path + 'BLD_Mindset_Tier040-min.png';
    }
    else if (traitGroupScore >= 30) {
        return path + 'BLD_Mindset_Tier030-min.png';
    }
    else if (traitGroupScore >= 20) {
        return path + 'BLD_Mindset_Tier020-min.png';
    }
    else if (traitGroupScore >= 10) {
        return path + 'BLD_Mindset_Tier010-min.png';
    }
    else if (traitGroupScore >= 0 || traitGroupScore === null) {
        return path + 'BLD_Mindset_Tier000-min.png';
    }
}

export const getLearningTexture = (traitGroupScore) => {
    let path = '';

    if (traitGroupScore >= 100) {
        return path + 'BLD_Learning_Tier100-min.png';
    }
    else if (traitGroupScore >= 90) {
        return path + 'BLD_Learning_Tier090-min.png';
    }
    else if (traitGroupScore >= 80) {
        return path + 'BLD_Learning_Tier080-min.png';
    }
    else if (traitGroupScore >= 70) {
        return path + 'BLD_Learning_Tier070-min.png';
    }
    else if (traitGroupScore >= 60) {
        return path + 'BLD_Learning_Tier060-min.png';
    }
    else if (traitGroupScore >= 50) {
        return path + 'BLD_Learning_Tier050-min.png';
    }
    else if (traitGroupScore >= 40) {
        return path + 'BLD_Learning_Tier040-min.png';
    }
    else if (traitGroupScore >= 30) {
        return path + 'BLD_Learning_Tier030-min.png';
    }
    else if (traitGroupScore >= 20) {
        return path + 'BLD_Learning_Tier020-min.png';
    }
    else if (traitGroupScore >= 10) {
        return path + 'BLD_Learning_Tier010-min.png';
    }
    else if (traitGroupScore >= 0 || traitGroupScore === null || traitGroupScore === null) {
        //console.log(traitGroupScore)
        return path + 'BLD_Learning_Tier000-min.png';
    }
}

export const getResilienceTexture = (traitGroupScore) => {
    let path = '';
    if (traitGroupScore >= 100) {
        return path + 'BLD_Resilience_Tier100-min.png';
    }
    else if (traitGroupScore >= 90) {
        return path + 'BLD_Resilience_Tier090-min.png';
    }
    else if (traitGroupScore >= 80) {
        return path + 'BLD_Resilience_Tier080-min.png';
    }
    else if (traitGroupScore >= 70) {
        return path + 'BLD_Resilience_Tier070-min.png';
    }
    else if (traitGroupScore >= 60) {
        return path + 'BLD_Resilience_Tier060-min.png';
    }
    else if (traitGroupScore >= 50) {
        return path + 'BLD_Resilience_Tier050-min.png';
    }
    else if (traitGroupScore >= 40) {
        return path + 'BLD_Resilience_Tier040-min.png';
    }
    else if (traitGroupScore >= 30) {
        return path + 'BLD_Resilience_Tier030-min.png';
    }
    else if (traitGroupScore >= 20) {
        return path + 'BLD_Resilience_Tier020-min.png';
    }
    else if (traitGroupScore >= 10) {
        return path + 'BLD_Resilience_Tier010-min.png';
    }
    else if (traitGroupScore >= 0 || traitGroupScore === null) {
        return path + 'BLD_Resilience_Tier000-min.png';
    }
}